"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleDelete = exports.ListKeymap = void 0;
const extension_list_keymap_1 = require("@tiptap/extension-list-keymap");
const names_1 = require("./utils/names");
const core_1 = require("@tiptap/core");
exports.ListKeymap = extension_list_keymap_1.ListKeymap.extend({
    addKeyboardShortcuts() {
        const parentKeyboardShortcuts = this.parent?.() ?? {};
        const customKeyboardShortcuts = {
            Delete: ({ editor }) => {
                let handled = false;
                this.options.listTypes.forEach(({ itemName }) => {
                    if (editor.state.schema.nodes[itemName] === undefined) {
                        return;
                    }
                    if ((0, exports.handleDelete)(editor, itemName)) {
                        handled = true;
                    }
                });
                return handled;
            },
            'Mod-Delete': ({ editor }) => {
                let handled = false;
                this.options.listTypes.forEach(({ itemName }) => {
                    if (editor.state.schema.nodes[itemName] === undefined) {
                        return;
                    }
                    if ((0, exports.handleDelete)(editor, itemName)) {
                        handled = true;
                    }
                });
                return handled;
            },
        };
        return {
            ...parentKeyboardShortcuts,
            ...customKeyboardShortcuts,
        };
    },
}).configure({
    listTypes: [
        {
            itemName: names_1.CustomListItemExtensionName,
            wrapperNames: [names_1.CustomBulletListExtensionName, names_1.CustomOrderedListExtensionName],
        },
    ],
});
function isAtEndOfFirstChildNode(state, nodeType) {
    const { $from, $to } = state.selection;
    // Ignore if the $from and $to position are not the same, as well as the nodeType not being available
    if ($from.pos === $to.pos && nodeType) {
        const parentNode = (0, core_1.findParentNode)((node) => node.type.name === nodeType)(state.selection);
        if (!parentNode) {
            return false;
        }
        const $parentPos = state.doc.resolve(parentNode.pos + 1);
        // Check if the position is at the end of the first child node
        if ($from.pos - ($parentPos.start() + 1) === parentNode.node.content.firstChild?.content.size) {
            return true;
        }
        return false;
    }
}
/**
 * Most of this code is taken from the original listKeymap tiptap extension, we are just trying to catch an edge case it doesn't cover.
 * @see https://github.com/ueberdosis/tiptap/blob/main/packages/extension-list-keymap/src/listHelpers/handleDelete.ts
 */
const handleDelete = (editor, name) => {
    // if the cursor is not inside the current node type
    // do nothing and proceed
    if (!(0, core_1.isNodeActive)(editor.state, name)) {
        return false;
    }
    // if the cursor is not at the end of a node
    // do nothing and proceed
    if (!isAtEndOfFirstChildNode(editor.state, name) && !(0, core_1.isAtEndOfNode)(editor.state, name)) {
        return false;
    }
    // if the selection is not collapsed, or not within a single node
    // do nothing and proceed
    const { selection } = editor.state;
    const { $from, $to } = selection;
    if (!selection.empty && $from.sameParent($to)) {
        return false;
    }
    // check if the next node is a list with a deeper depth
    if (extension_list_keymap_1.listHelpers.nextListIsDeeper(name, editor.state)) {
        return editor
            .chain()
            .focus(editor.state.selection.from + 4)
            .liftListItem(name)
            .joinItemBackward()
            .run();
    }
    if (extension_list_keymap_1.listHelpers.nextListIsHigher(name, editor.state)) {
        return editor.chain().joinForward().joinBackward().run();
    }
    return editor.commands.joinItemForward();
};
exports.handleDelete = handleDelete;
//# sourceMappingURL=list-key-item.js.map